import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface UserCertificateDto {
  id?: number;
  issuerCn?: string;
  issuerOu?: string;
  issuerO?: string;
  issuerL?: string;
  issuerC?: string;
  subjectE?: string;
  subjectCn?: string;
  subjectOu?: string;
  subjectO?: string;
  subjectL?: string;
  subjectC?: string;
  validFrom?: string;
  validTo?: string;
  certificateFile?: string;
  certificateFileName?: string;
  certificateFileExists?: boolean;
  createdTime?: string;
  userId?: number;
}

@Injectable({ providedIn: 'root' })
export class UserCertificateService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/identity/my-certificate';

  getMyCertificate(): Observable<UserCertificateDto> {
    return this.http.get<UserCertificateDto>(this.apiUrl);
  }

  ensureMyCertificate(): Observable<UserCertificateDto> {
    return this.http.post<UserCertificateDto>(`${this.apiUrl}/ensure`, {});
  }

  previewMyCertificate(file: File, password: string): Observable<UserCertificateDto> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('password', password);
    return this.http.post<UserCertificateDto>(`${this.apiUrl}/preview`, formData);
  }

  uploadMyCertificate(file: File, password: string): Observable<UserCertificateDto> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('password', password);
    return this.http.post<UserCertificateDto>(`${this.apiUrl}/upload`, formData);
  }

  /** blob download via the secured endpoint — a plain <a href> cannot carry the JWT. */
  downloadMyCertificateFile(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/file`, {responseType: 'blob'});
  }
}
